import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CopyIcon } from 'assets/icons';
import { TextEllipsisTooltip, WarningAlert } from 'common/components';
import { useCopyToClipboard } from 'common/hooks';
import { CopyIconWrapper } from 'modules/accommodations/features/reservations/components/ReservationInfo/ReservationOverview/ReservationOverview.styled';
import { useTheme } from 'styled-components';

export const CopyToClipboard = ({
  valueToCopy,
  hoverTooltipText,
  onClickCopyText,
  iconColor,
}: {
  valueToCopy: string;
  hoverTooltipText: string;
  onClickCopyText: string;
  iconColor?: string;
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const { isDelay, copyToClipboardHandler } = useCopyToClipboard();

  const [tooltipHide, setTooltipHide] = useState(true);

  const copyToClipboard = (value: string) => {
    copyToClipboardHandler(value);
  };

  const hideTooltip = () => {
    setTooltipHide(false);
  };

  const resetTooltipToInitial = () => {
    setTooltipHide(true);
  };

  return (
    <CopyIconWrapper onClick={() => copyToClipboard(valueToCopy)}>
      <TextEllipsisTooltip
        display={tooltipHide}
        onClick={hideTooltip}
        onMouseLeave={resetTooltipToInitial}
        data-tooltip={t(hoverTooltipText)}
        leftAfter="-20px"
        bottomAfter="140%"
        topBefore="-5px"
      >
        <CopyIcon width={20} height={20} stroke={iconColor} />
      </TextEllipsisTooltip>

      {isDelay && (
        <WarningAlert
          text={t(onClickCopyText)}
          confirmInfo
          showCloseIcon={false}
          margin="0"
          additionalStyle={{
            position: 'absolute',
            top: '-3rem',
            right: '-2.5rem',
            backgroundColor: colors.white,
          }}
        />
      )}
    </CopyIconWrapper>
  );
};
